import { recentListingStatus, marketReportStatus } from '../_config';
import { usePageStore } from '@/store';

export default {
    //  transfer  market report The parameters that need to be passed 
    marketReportParams(state) {
        let { siteId } = usePageStore(this.$pinia);
        return {
            ...state.searchParams,
            siteId
        };
    },
    //  call get listing  interface   The parameters that need to be passed 
    listingParams(state) {
        let { siteId } = usePageStore(this.$pinia);
        return {
            ...state.searchParams,
            siteId,
            listingStatus: state.currentListingStatus,
            page: state.pageNum,
            pageSize: state.pageSize
        };
    },
    // market snapshot Related status display 
    showMarketReportData(state) {
        return (
            (state.fetchMarketReportStatus === marketReportStatus.loading ||
                state.fetchMarketReportStatus === marketReportStatus.loaded) &&
            !this.showMarketNoData
        );
    },
    showMarketReportLoading(state) {
        return state.fetchMarketReportStatus === marketReportStatus.loading;
    },
    showMarketNoLocation(state) {
        return state.fetchMarketReportStatus === marketReportStatus.noLocation;
    },
    showMarketComing(state) {
        return state.fetchMarketReportStatus === marketReportStatus.coming;
    },
    showMarketNoData(state) {
        const { count, avgSoldPrice, avgOnSaleDays } = state.marketReport;
        return (
            state.fetchMarketReportStatus !== marketReportStatus.coming &&
            state.fetchMarketReportStatus !== marketReportStatus.noLocation &&
            count === 0 &&
            avgSoldPrice === 0 &&
            avgOnSaleDays === 0
        );
    },
    // recent listing Related status display 
    showRecentListingData(state) {
        return (
            (state.fetchListingStatus === recentListingStatus.loading ||
                state.fetchListingStatus === recentListingStatus.loaded) &&
            !this.showRecentListingNoData
        );
    },
    showRecentListingLoading(state) {
        return state.fetchListingStatus === recentListingStatus.loading;
    },
    showRecentListingNoLocation(state) {
        return state.fetchListingStatus === recentListingStatus.noLocation;
    },
    showRecentListingComing(state) {
        return state.fetchListingStatus === recentListingStatus.coming;
    },
    showRecentListingNoData(state) {
        return (
            state.fetchListingStatus !== recentListingStatus.coming &&
            state.fetchListingStatus !== recentListingStatus.noLocation &&
            state.listing.length === 0
        );
    },
    //  whether or not sold listing
    isSoldListing(state) {
        return state.currentListingStatus.toLowerCase() === 'sold';
    },
    hasLocation(state) {
        let { page: globalData } = usePageStore(this.$pinia);
        if (globalData.searchCenter) {
            try {
                if (!state.searchParams?.condition) {
                    return false;
                }
                const condition = JSON.parse(state.searchParams.condition);
                if (
                    condition.location &&
                    Object.keys(condition.location).length > 0
                ) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.log(e);
                return false;
            }
        } else {
            return (
                !!state.searchParams.key ||
                !!state.searchParams.mapPath ||
                !!state.searchParams.mapRadius ||
                (state.searchParams.mapSearch && state.searchParams.rect)
            );
        }
    }
};
